import { render, staticRenderFns } from "./BlocoResumo.vue?vue&type=template&id=21f337d9&lang=pug"
import script from "./BlocoResumo.vue?vue&type=script&lang=js"
export * from "./BlocoResumo.vue?vue&type=script&lang=js"
import style0 from "./BlocoResumo.vue?vue&type=style&index=0&id=21f337d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports